import { render } from "./Calendar.vue?vue&type=template&id=220ec83e&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=220ec83e&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220ec83e"]])

export default __exports__